import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import { Provider } from "react-redux";
import { store } from "./Redux/Store";
import { AliveScope } from "react-activation";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
const container = document.getElementById("root");
const root = createRoot(container);
const queryClient = new QueryClient();

root.render(
       <AliveScope>
  <Provider store={store}>
     <QueryClientProvider client={queryClient}>
    <BrowserRouter future={{
           v7_relativeSplatPath: true,
           v7_startTransition: true,
         }}>
      <App />
    </BrowserRouter>
    </QueryClientProvider>
  </Provider>
  </AliveScope>
)